export enum CheckoutTypeEnum {
  register = 'register',
  withoutRegister = 'withoutRegister',
  passwordRecovery = 'passwordRecovery',
}
